export default class FindingStatus {
  static open = 0;
  static closed = 1;
  static pending = 2;
}
